import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdd428d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "cd-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "card-icon" }, null, -1))
const _hoisted_4 = { class: "cd-right" }
const _hoisted_5 = { class: "card-content" }

import TimelineHorizontal from "@/components/TimelineHorizontal.vue";
import { nextTick, onMounted, ref, watch } from "vue";
import dayjs from "dayjs";
import { getCustomerTrack } from "@/service/desk-top/custom-detail";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeLineCard',
  props: {
  title: {
    type: String,
    default: ''
  },
  modelValue: {
    type: Array,
    default: []
  },
  unionId: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

watch(() => props.unionId, () => {
  getData(false)
})

const type: any = ref('month')
const currentDate: any = ref(dayjs())

const getDateSelectFormat = (type: String) => {
  switch (type)
  {
    case 'day':
      return 'YYYY-MM-DD'
    case 'week':
      return '[第] ww [周]'
    case 'month':
      return 'YYYY-MM'
    case 'daterange':
      return 'YYYY-MM-DD'
  }
}

const getData = (flag: boolean) => {
  let time:any = []
  if(flag) {
    currentDate.value = null
    nextTick(() => {
      if(type.value == 'daterange') {
        currentDate.value = [dayjs(), dayjs()]
      } else {
        currentDate.value = dayjs()
      }
    })
  }
  if(currentDate.value) {
    if(currentDate.value instanceof Array) {
      time = [
        dayjs(currentDate.value[0]).startOf("day").format('YYYY-MM-DD HH:mm:ss'),
        dayjs(currentDate.value[1]).endOf("day").format('YYYY-MM-DD HH:mm:ss'),
      ]
    } else {
      time = [
        dayjs(currentDate.value).startOf(type.value).format('YYYY-MM-DD HH:mm:ss'),
        dayjs(currentDate.value).endOf(type.value).format('YYYY-MM-DD HH:mm:ss'),
      ]
    }
  } else {
    time = [
      dayjs().startOf(type.value).format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf(type.value).format('YYYY-MM-DD HH:mm:ss'),
    ]
  }
  const queryInfo = {
    unionId: props.unionId,
    accessDate: time
  }
  getCustomerTrack(queryInfo).then((res: any) => {
    timelineData.value = res
    emits('update:modelValue', res)
  })
}

const timelineData: any = ref([])

onMounted(() => {
  getData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            style: {"width":"90px","margin-right":"12px"},
            modelValue: type.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (getData(true))),
            size: "mini",
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "时间段",
                value: "daterange"
              }),
              _createVNode(_component_el_option, {
                label: "月",
                value: "month"
              }),
              _createVNode(_component_el_option, {
                label: "周",
                value: "week"
              }),
              _createVNode(_component_el_option, {
                label: "日",
                value: "day"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_date_picker, {
            style: _normalizeStyle(type.value == 'daterange'?{width: '270px',marginLeft: '12px'}:{width: '130px',marginLeft: '12px'}),
            size: "mini",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (getData(false))),
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentDate).value = $event)),
            format: getDateSelectFormat(type.value),
            type: type.value,
            placeholder: "请选择日期"
          }, null, 8, ["style", "modelValue", "format", "type"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (timelineData.value.length > 0)
          ? (_openBlock(), _createBlock(TimelineHorizontal, {
              key: 0,
              "timeline-data": timelineData.value
            }, null, 8, ["timeline-data"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "暂无数据"
            }))
      ])
    ]),
    _: 1
  }))
}
}

})